import React from "react";
import { useNavigate } from "react-router-dom";

class ErrorBoundaryClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <this.props.Fallback
          error={this.state.error}
          resetError={() => this.setState({ hasError: false, error: null })}
        />
      );
    }
    return this.props.children;
  }
}

function ErrorFallback({ error, resetError }) {
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        backgroundColor: "#f5f5f5",
        color: "#333",
        textAlign: "center",
      }}
    >
      <h2 style={{ marginBottom: "1rem", fontSize: "1.25rem" }}>
        Something went wrong
      </h2>
      <p style={{ marginBottom: "1.5rem", color: "#666", fontSize: "0.875rem" }}>
        {error?.message || "An error occurred. Please try again."}
      </p>
      <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
        <button
          type="button"
          onClick={() => {
            resetError();
            window.location.reload();
          }}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#F4802C",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "0.875rem",
          }}
        >
          Reload page
        </button>
        <button
          type="button"
          onClick={() => {
            resetError();
            navigate("/dashboard");
          }}
          style={{
            padding: "0.5rem 1rem",
            backgroundColor: "#73885f",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "0.875rem",
          }}
        >
          Go to Dashboard
        </button>
      </div>
    </div>
  );
}

export default function ErrorBoundary({ children }) {
  return (
    <ErrorBoundaryClass Fallback={ErrorFallback}>
      {children}
    </ErrorBoundaryClass>
  );
}
